import * as types from './types';
import actions from './actions';
import {
  extend,
  each,
  set
} from 'lodash';

const state = {
  //教材计划列表
  schoolAdminToolBookStatementClassCourseList: {
    state: '',
    list: [],
    total: 0,
  },
  //课程类型列表
  schoolAdminToolBookStatementCourseTypeList: {
    state: '',
    list: [],
    total: 0,
  },
  //结算班级列表
  schoolAdminToolBookStatementClassList: {
    state: '',
    list: [],
    total: 0,
    receive_payment_total:0,
    management_cost_total:0,
    management_cost_export_url:null,
    qr_code_url:null,
    class_student_book_catalog_export_url:null
  },
  bookStatementBookCatalogCreate: {
    begin_class:'',
    book_booking_total:'',
    book_character:'',
    book_discount:'',
    book_isbn:'',
    book_price:'',
    book_statement_catalog_id:'',
    book_statement_class_id:'',
    book_statement_course_id:'',
    book_statement_id:'',
    book_statement_provider_id:'',
    edition:'',
    type:'',
  },
  editingTheTeachingMaterial: {
    author_name:'',
    book_character:'',
    book_discount:'',
    book_isbn:'',
    book_name:'',
    book_price:'',
    book_statement_catalog_id:'',
    book_statement_id:'',
    book_statement_provider_id:'',
    book_tag:'common',
    edition:'',
    press:'',
  },
  bookStatementBookDiscount: {
    scope: 'all',
    discount: '',
  },
  //数据导入列表
  schoolAdminToolDataImportList: {
    state: '',
    list: [],
    total: 0,
  },
  //班级学生信息列表
  classStudentMassageList:{
    state: '',
    list: [],
    total: 0,
  },
  //课程用书列表
  schoolAdminToolBookStatementBookCatalog: {
    state: '',
    list: [],
    total: 0,
  },
  editingClassManagementName: {
    class_name: '',
    select_college:'',
    book_statement_college_id:'',
  },
  toolDataImportProcessDetail: {
    state : '',
  },
  settleAccountsCollegeList:{
    state: '',
    list: [],
    total: 0,
  },
  selectClassList:{

  }
};

const getters = {
  //教材计划列表
  getSchoolAdminToolBookStatementClassCourseList: (state) => state.schoolAdminToolBookStatementClassCourseList,
  //课程类型列表
  getSchoolAdminToolBookStatementCourseTypeList: (state) =>state.schoolAdminToolBookStatementCourseTypeList,
  //结算班级列表
  getSchoolAdminToolBookStatementClassList: (state) =>state.schoolAdminToolBookStatementClassList,
  getBookStatementBookCatalogCreate: (state) =>state.bookStatementBookCatalogCreate,
  getEditingTheTeachingMaterial: (state) => state.editingTheTeachingMaterial,//编辑教材管理
  getBookStatementBookDiscount: (state) =>state.bookStatementBookDiscount,
  getSettleAccountsCollegeList: (state) =>state.settleAccountsCollegeList,//结算学院列表
  //数据导入列表
  getSchoolAdminToolDataImportList: (state) =>state.schoolAdminToolDataImportList,
  //课程用书列表
  getSchoolAdminToolBookStatementBookCatalog: (state) =>state.schoolAdminToolBookStatementBookCatalog,
  getClassStudentMassageList: (state) =>state.classStudentMassageList,
  getEditingClassNameManagement: (state) => state.editingClassManagementName,
  getToolDataImportProcessDetail: (state) => state.toolDataImportProcessDetail,
  getSelectClassList: (state) =>state.selectClassList,//选班容器
};

const mutations = {
  //教材计划列表
  [types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_COURSE_LIST]({schoolAdminToolBookStatementClassCourseList}, result){
    extend(schoolAdminToolBookStatementClassCourseList, result)
  },
  [types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_COURSE_TYPE_LIST]({schoolAdminToolBookStatementCourseTypeList}, result){
    extend(schoolAdminToolBookStatementCourseTypeList, result)
  },
  //结算班级列表
  [types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_LIST]({schoolAdminToolBookStatementClassList}, result){
    extend(schoolAdminToolBookStatementClassList, result)
  },
  [types.BOOK_STATEMENT_BOOK_CATALOG_CREATE]({bookStatementBookCatalogCreate}, result){
    extend(bookStatementBookCatalogCreate, result)
  },
  [types.EDITING_THE_TEACHING_MATERIAL]({editingTheTeachingMaterial}, result){
    extend(editingTheTeachingMaterial, result)
  },
  [types.BOOK_STATEMENT_BOOK_DISCOUNT]({bookStatementBookDiscount}, result){
    extend(bookStatementBookDiscount, result)
  },
  //数据导入列表
  [types.ACTION_SCHOOL_ADMIN_TOOL_DATA_IMPORT_LIST]({schoolAdminToolDataImportList}, result){
    extend(schoolAdminToolDataImportList, result)
  },
  //课程用书列表
  [types.ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_BOOK_CATALOG](state, result){
    state.schoolAdminToolBookStatementBookCatalog = extend({}, result)
  },
  //班级学生信息列表
  [types.ACTION_GET_CLASS_STUDENT_MASSAGE_LIST_PORT_MODEL]({classStudentMassageList}, result){
    extend(classStudentMassageList, result)
  },
  [types.EDITING_CHANGE_CLASS_MANAGEMENT_NAME]({editingClassManagementName}, result){
    extend(editingClassManagementName, result)
  },
  [types.ACTION_ADMIN_TOOL_DATA_IMPORT_PROCESS_DETAIL](state, result){
    state.toolDataImportProcessDetail = result;
  },
  //结算学院列表
  [types.ACTION_SETTLE_ACCOUNTS_COLLEGE_LIST_PORT]({settleAccountsCollegeList}, result){
    extend(settleAccountsCollegeList, result)
  },
  [types.ACTION_CHANGE_CLASS_LIST_OF_BATCH](state, result){
    state.selectClassList = extend({}, state.selectClassList, result);
  }
};


export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Admin/modules/textBookSchedule/index.js